import React from "react";
import { Grid, Paper, makeStyles } from "@material-ui/core";
import MainToolbar from "../MainToolbar";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    // flexDirection: "column",
    backgroundColor: "#EFF2F8",
  },
  content: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(2),
    margin: '20px',
  },
  form: {
    padding: theme.spacing(1, 2, 2),
  },
}));

const ReportLayoutPage = ({ children, filter }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <MainToolbar />
      <div className={classes.content}>

        <Grid container spacing={2}>
              {filter}
            {children}
        </Grid>
      </div>
    </div>
  );
};

export default ReportLayoutPage;
